module.exports = __webpack_public_path__ + "static/media/07_ladoalado_mobile.10768476.jpg";